<template>
    <div>
        <CRow>
            <CCol md="5">
                <CCard>
                    <CCardBody>
                        <CCardHeader class="p-1">
                            <CRow>
                                <CCol col="6" style="text-align: start ;padding:10px 20px 0 20px ">

                                    <strong>{{$t('RouteInsert')}}</strong>

                                </CCol>
                                <CCol col="6" style="text-align: end">


                                    <CButton  class="mr-1 ml-1" @click="insert_route()"
                                             type="submit" size="sm"
                                             color="secondary">
                                        {{ $t('buttons.submit') }}
                                    </CButton>

                                    <CButton
                                            v-if="route_status_form!=0"
                                            size="sm"
                                            @click="route_status_form=0,route_name='',route_code=''"

                                            color="secondary"

                                    >{{ $t("buttons.cancel") }}
                                    </CButton>

                                </CCol>
                            </CRow>
                        </CCardHeader>

                        <CRow>
                            <CCol col="6">
                                <CInput
                                        :label="$t('routeName')"
                                        :value.sync="route_name"/>

                            </CCol>
                            <CCol col="6">
                                <CInput
                                        :label="$t('routeCode')"
                                        :value.sync="route_code"/>

                            </CCol>

                        </CRow>

                        <CCard>
                            <CCardHeader>
                                <strong>{{$t('routes')}}</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CRow>
                                    <CCol col="12">
                                        <CDataTable
                                                :fields="fields_routes"
                                                :items="route_items"
                                                :items-per-page="20"
                                                hover
                                                striped
                                                border
                                                sorter
                                                @row-clicked="table_route_clicked"

                                                pagination
                                        >

                                            <template v-slot:[item_row_name]="{item}">

                                                <td style="text-align: center">
                                                    <p >{{ item.row_id + 1 }}</p>
                                                </td>
                                            </template>
                                            <template #operation="{item}">
                                                <td>

                                                    <CButton
                                                            color="danger"
                                                            variant="outline"
                                                            square
                                                            size="sm"
                                                            @click="delete_route_dialog(item)"
                                                    >
                                                        <CIcon name="cil-trash"></CIcon>
                                                    </CButton>

                                                </td>
                                            </template>


                                        </CDataTable>
                                    </CCol>
                                </CRow>
                            </CCardBody>

                        </CCard>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol md="7" v-if="selected_route_name_id != 0">
                <CCard>
                    <CCardBody>
                        <CCardHeader class="p-1">
                            <CRow>
                                <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                                    <strong>{{selected_route_name}}</strong>

                                </CCol>
                                <CCol col="4" style="text-align: end">


<!--                                    <CButton  class="mr-1 ml-1" @click="insert_route_data()"-->
<!--                                             type="submit" size="sm"-->
<!--                                             color="secondary">-->
<!--                                        {{ $t('buttons.submit') }}-->
<!--                                    </CButton>-->


                                </CCol>
                            </CRow>
                        </CCardHeader>

                        <CRow>
                            <CCol col="4">
                                <CSelect
                                        :label="$t('country')"

                                        :value.sync="selected_country"
                                        :options="country_items"
                                />
                            </CCol>

                            <CCol col="4">
                                <CSelect
                                        :label="$t('components.province')"

                                        :options="province_items"
                                        :value.sync="selected_province"/>

                            </CCol>
                            <CCol col="4">
                                <CSelect
                                        :label="$t('components.city')"

                                        :options="city_items"
                                        :value.sync="selected_city"/>

                            </CCol>
                            <CCol col="4">
                                <CSelect
                                        :label="$t('town')"

                                        :options="district_items"
                                        :value.sync="selected_district"/>
                            </CCol>
                            <CCol col="4">
                                <CSelect
                                        :label="$t('components.area')"

                                        :options="area_items"
                                        :value.sync="selected_area"/>

                            </CCol>
                          <CCol col="4">
                            <label></label>
                            <br>
                            <CButton
                                    color="primary"
                                    variant="outline"
                                    square
                                    size="sm"
                                    @click="insert_route_data()"
                            >
                              <CIcon size="sm" name="cil-plus"></CIcon>
                            </CButton>
                          </CCol>

                        </CRow>

                        <CCard>
                            <CCardHeader>
                                <strong>{{$t('routes')}}</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CRow>

                                    <CCol col="12">
                                        <CDataTable
                                                :fields="fields_sub_routes"
                                                :items="route_sub_items"
                                                :items-per-page="20"
                                                hover
                                                striped
                                                border
                                                sorter
                                                pagination
                                        >

                                            <template v-slot:[item_row_name]="{item}">

                                                <td style="text-align: center">
                                                    <p >{{ item.row_id + 1 }}</p>

                                                </td>

                                            </template>
                                            <template #user="{item}">

                                                <td>
                                                    <p >{{ item.personName }}</p>

                                                </td>

                                            </template>


                                            <template #operation="{item}">
                                                <td>

                                                    <CButton
                                                            color="danger"
                                                            variant="outline"
                                                            square
                                                            size="sm"
                                                            @click="delete_sub_route_dialog(item)"
                                                    >
                                                        <CIcon name="cil-trash"></CIcon>
                                                    </CButton>
                                                </td>
                                            </template>


                                        </CDataTable>

                                    </CCol>
                                </CRow>
                            </CCardBody>

                        </CCard>
                    </CCardBody>
                </CCard>
            </CCol>

        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import BTabs from "../../tabs/BTabs";
    import Vue from "vue";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items = [];


    export default {
        name: 'Login',
        components: {
            BTabs,
            Treeselect,

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                collapse: false,
                validate_errors: [],
                route_name: '',
                route_code: '',
                person_name: '',
                person_mobile: '',
                car_pelak: '',
                car_type: 0,
                car_name: 0,
                car_title: '',
                mizan_bar: '',
                car_volume: '',
                item_row_name: 'row',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                car_items: [],
                route_items: [],
                route_sub_items: [],
                driver_items: [],

                fields_routes: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
                    {key: 'title', label: this.$t('routeName'), _style: 'width:50%'},
                    {key: 'code', label: this.$t('routeCode'), _style: 'width:40%'},
                    // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},
                ],
                fields_sub_routes: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                    {key: 'provinceName', label: this.$t('components.province'), _style: 'width:10%'},
                    {key: 'cityName', label: this.$t('components.city'), _style: 'width:10%'},
                    {key: 'regionName', label: this.$t('town'), _style: 'width:10%'},
                    {key: 'areaName', label: this.$t('tables.area'), _style: 'width:10%'},
                    // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},
                ],

                car_type_items: [],

                car_name_items: [],

                selected_driver_car: 0,
                driver_car_items: [],

                driver_route_items: [],

                document_person: null,

                area_items: [],
                selected_area: 0,

                province_items: [],
                selected_province: 0,

                city_items: [],
                selected_city: 0,

                district_items: [],
                selected_district: 0,

                details: [],
                collapseDuration: 0,
                selected_route_name: "",
                selected_route_name_id: 0,
                // status_form: 0,
              table_clicks:0,
              table_clicks_timer:'',

                country_items: [],
                selected_country: 0,


                route_detail_status_form: 0,
                route_status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
                static_user_names: [],
                static_user_state: true,
            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];

            this.get_route_lists();
            // this.get_driver_lists();
            // this.get_lists();
            this.get_country()

            bus.$on('close_add_base_modal', (data) => {
                this.get_areas();
            });

            bus.$on('delete_route_confirm'+this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_route_item();

                } else {
                    this.route_status_form = 0;
                }
            });
            bus.$on('delete_sub_route_confirm'+this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_sub_route_item();

                } else {
                    this.route_detail_status_form = 0;
                }
            });

        },
        watch: {
            'document_person': function () {
                // this.get_user_data();
            },
            'selected_province': function () {
                this.get_cities();
            },
            'selected_city': function () {
                this.get_districts();
            },
            'selected_district': function () {
                this.get_areas();
            },
            'selected_country': function () {
                this.get_provinces();
            },
        },
        methods: {
            go_to_add_modal(func) {
                bus.$emit("show_add_base_modal", func);
            },

            inline_item_edit(item, index) {
                // var item = [];
// this.items[0] = item;
                console.log("edit item");
                this.selected_province = item.province;
                this.selected_city = item.city;
                this.selected_district = item.district;
                this.selected_area = item.area;
                this.inline_status_form = index;
            },
            inline_item_delete(index) {
            },
            table_route_clicked(item, index) {
                this.selected_route_name = item.title
                this.selected_route_name_id = item.id
                this.route_sub_items = item.details.map((item, row_id) => {
                    return {...item, row_id}
                });

              this.table_clicks++;
              if (this.table_clicks == 1) {
                this.table_clicks_timer = setTimeout(() => {
                  // this.result.push(event.type);
                  this.table_clicks = 0
                }, 500);
              } else if (this.table_clicks > 1) {
                clearTimeout(this.table_clicks_timer);
                this.edit_item(item)
                this.table_clicks = 0

              }
            },
          edit_item(item) {
            this.route_name = item.title;
            this.route_code = item.code;
            this.route_status_form = item.id;


          },
            validateRouteForm: function () {
                this.$root.root_validate_errors = [];

                if (this.route_name != '' && this.route_code != '') {
                    return true;
                }


                if (this.route_name == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
                }
                if (this.route_code == 0) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
                }


                return false;
                // e.preventDefault();
            },
            validateRouteDetailForm: function () {
                this.$root.root_validate_errors = [];

                if (this.selected_district != 0) {
                    return true;
                }

                if (this.selected_district == 0) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertArea'));
                }


                return false;
                // e.preventDefault();
            },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },

            get_route_lists() {
                var self = this;

                const formData = new FormData();

                axios.post('GetRoutesNew', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.route_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });

                        console.log(' self.selected_route_name_id', self.selected_route_name_id)
                        if (self.selected_route_name_id != 0) {
                            var item = self.route_items.filter(x => x.id == self.selected_route_name_id)[0]
                            self.selected_route_name = item.title
                          self.selected_route_name_id = item.id
                          self.route_sub_items = item.details.map((item, row_id) => {
                                return {...item, row_id}
                            });
                        } else {
                            if (self.route_items.length > 0) {
                                var item2 = self.route_items[0]

                              self.selected_route_name = item2.title
                              self.selected_route_name_id = item2.id
                              self.route_sub_items = item2.details.map((item, row_id) => {
                                    return {...item, row_id}
                                });

                            }
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            delete_route_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], 'delete_route_confirm'+this.confirm_delete_name);
                this.route_status_form = item.id;
            },
          delete_sub_route_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], 'delete_sub_route_confirm'+this.confirm_delete_name);
                this.route_detail_status_form = item.id;
            },
            delete_route_item() {
                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteMasterRouteNew";
                formData.append('id', this.route_status_form);

                axios.post(url, formData, {}).then((res) => {
                  self.$root.modal_component.show_api_response_modals(res);
                    self.route_status_form = 0;
                    self.get_route_lists();
                }).catch(function (error) {
                    console.log(error);
                });
            },
            delete_sub_route_item() {
                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteRouteDetailNew";
                formData.append('id', this.route_detail_status_form);

                axios.post(url, formData, {}).then((res) => {
                  self.$root.modal_component.show_api_response_modals(res);
                    self.route_detail_status_form = 0;
                    self.get_route_lists();
                }).catch(function (error) {
                    console.log(error);
                });
            },
            insert_route() {

                if (!this.validateRouteForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;

                if (this.route_status_form == 0) {
                    url = "AddMasterRouteNew";
                } else {
                    url = "EditMasterRouteNew";
                    formData.append('Id', this.route_status_form)
                }

                formData.append('Title', this.route_name);
                formData.append('Code', this.route_code);

                // formData.append('Items',JSON.stringify(items_route));

                axios.post(url, formData, {}).then((res) => {

                    self.route_status_form = 0;
                    self.route_name = '';
                    self.route_code = '';
                    // self.description = '';
                    // self.previewImage = '';
                    self.get_route_lists();

                  self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            insert_route_data() {

                if (!this.validateRouteDetailForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;

                if (this.route_detail_status_form == 0) {
                    url = "AddRouteDetailNew";
                } else {
                    url = "EditRouteDetailNew";
                    formData.append('Id', this.route_detail_status_form)
                }


                // DeleteRouteDetailNew
                // formData.append('Title', this.route_name);
                // formData.append('Code', this.route_code);

                formData.append('CountryId', this.selected_country);
                formData.append('ProvinceId', this.selected_province);
                formData.append('CityId', this.selected_city);
                formData.append('RegionId', this.selected_district);
                formData.append('AreaId', this.selected_area);
                formData.append('RouteId', this.selected_route_name_id);

                axios.post(url, formData, {}).then((res) => {
                    self.route_detail_status_form = 0;
                    self.route_name = '';
                    self.route_code = '';
                    // self.description = '';
                    // self.previewImage = '';
                    self.get_route_lists();

                  self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];
                        var obj = {label: self.$t('Country'), value: 0}
                        self.country_items.push(obj);
                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');

                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.province_items = [];

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id', 'provinceName');


                        self.selected_province = self.province_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.city_items = []
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');

                        self.selected_city = self.city_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_districts() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_city);

                axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.district_items = []
                        self.district_items = self.sort_array(
                            self.district_items, content_data.data,
                            'id', 'title');

                        self.selected_district = self.district_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_areas() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_district);

                axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.area_items = [{label:self.$t('select'),value:0}]
                        self.area_items = self.sort_array(
                            self.area_items, content_data.data,
                            'id', 'areaName');

                        // content_data.data.forEach((val) => {
                        //   var obj = {label: val.areaName, value: val.id}
                        //
                        //   self.area_items.push(obj);
                        // });
                        self.selected_area = 0;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }

</script>
